import * as React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import Footer from "../components/Footer";
import Reviews from "../components/Reviews";

import { Accordion, Placeholder, Modal } from 'rsuite';
import 'rsuite/dist/rsuite-no-reset.min.css';
import Subscribe from "../components/Subscribe";

import ReactGA from 'react-ga4';

export default class GoldenCircle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navActive: false,
      screenWidth: window.innerWidth,
      modalOpen: false,
      modalCurrentID: 1,
      gallery: [
        { url: "/img/NorseAdventures_2024%200-1920.jpg" },
        { url: "/img/DSC_1631.jpg" },
        { url: "/img/DSC_1673.jpg" },
        { url: "/img/DSC_1702.jpg" },
        { url: "/img/DSC_1652.jpg" },
        { url: "/img/Island_web3-resize-compress.jpg" },
      ]
    };

    this.hideNav = this.hideNav.bind(this);
    this.showNav = this.showNav.bind(this);
    this.previousImage = this.previousImage.bind(this);
    this.nextImage = this.nextImage.bind(this);

    this.handleOpen = (_id) => this.setState({ modalOpen: true, modalCurrentID: _id });
    this.handleClose = () => this.setState({ modalOpen: false });

    window.addEventListener('keyup', e => {
      if (e.key === 'ArrowLeft') this.previousImage();
      else if (e.key === 'ArrowRight') this.nextImage();
    })
  }

  previousImage() {
    this.setState({ modalCurrentID: this.state.modalCurrentID > 1 ? this.state.modalCurrentID - 1 : this.state.gallery.length })
  }

  nextImage() {
    this.setState({ modalCurrentID: this.state.modalCurrentID < this.state.gallery.length ? this.state.modalCurrentID + 1 : 1 })
  }

  hideNav() {
    this.setState({ navActive: false });
  }

  showNav() {
    this.setState({ navActive: true });
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    if (this.state.navActive && window.innerWidth < 1440) {
      document.body.classList.add("overflow-hidden");
    } else document.body.classList.remove("overflow-hidden");

    window.addEventListener("resize", () => {
      this.setState({
        screenWidth: window.innerWidth,
      });
      if (this.state.navActive && window.innerWidth < 1440) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
        this.hideNav();
      }
    });

    if (typeof window.BokunWidgets !== "undefined") window.BokunWidgets.setCurrency("ISK");

    document.title = "Golden Circle Luxury Private Tour - Local Icelandic Guide";

    ReactGA.initialize('G-CZG7EJ3P8E');
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }

  componentDidUpdate() {
    if (this.state.navActive && window.innerWidth < 1440) {
      document.body.classList.add("overflow-hidden");
    } else document.body.classList.remove("overflow-hidden");
  }

  render() {
    return (
      <div className="App flex flex-col items-center">

        <div className="bg-gray-900 text-white w-full p-2">
          The website is in development so you can expect some errors or display
          problems. Not all buttons and links work.
        </div>

        <header
          className={
            "flex flex-col items-center desktop:justify-center w-full group overflow-hidden" +
            (this.state.navActive & (this.state.screenWidth < 1440)
              ? " absolute"
              : " h-screen relative")
          }
        >
          <div
            className={
              "z-40 flex flex-row items-center justify-center w-full desktop:h-auto desktop:absolute desktop:top-0 desktop:left-0" +
              (this.state.navActive & (this.state.screenWidth < 1440)
                ? " h-screen flex-col"
                : "")
            }
          >
            <div
              className={
                "w-full h-full desktop:max-w-[1280px] flex bg-neutral-900 text-white desktop:m-16" +
                (this.state.navActive & (this.state.screenWidth < 1440)
                  ? " flex-col items-center justify-center"
                  : " flex-row" + (this.state.screenWidth < 1440 ? " bg-opacity-100" : " bg-opacity-90"))
              }
            >
              <a href="/">
                <div className="p-8 hover:bg-neutral-900">
                  <img
                    src="/runes.svg"
                    alt="Norse Logo"
                    className="invert w-48"
                  />
                </div>
              </a>
              <div
                id="navlinks"
                className={
                  "flex flex-col desktop:flex-row desktop:ml-auto text-xl font-black" +
                  (!this.state.navActive ? " ml-auto" : "")
                }
              >
                {this.state.navActive || this.state.screenWidth >= 1440 ? (
                  <>
                    <HashLink
                      onClick={this.hideNav}
                      className="p-8 hover:bg-neutral-900 h-full flex flex-col justify-center"
                      to="/#adventures"
                    >
                      ADVENTURES
                    </HashLink>
                    <Link
                      onClick={this.hideNav}
                      className="p-8 hover:bg-neutral-900 h-full flex flex-col justify-center"
                      to="/about-us"
                    >
                      ABOUT US
                    </Link>
                    <Link
                      onClick={this.hideNav}
                      className="p-8 hover:bg-neutral-900 h-full flex flex-col justify-center items-center"
                      to="/blog"
                    >
                      BLOG
                    </Link>
                    <a
                      onClick={this.hideNav}
                      className="p-8 hover:bg-neutral-900 h-full flex flex-col justify-center"
                      href="#contact-us"
                    >
                      CONTACT US
                    </a>
                  </>
                ) : (
                  <button onClick={this.showNav} className="text-3xl p-8">
                    ☰
                  </button>
                )}
              </div>
            </div>
          </div>

          {this.state.navActive && (
            <button
              onClick={this.hideNav}
              className="text-3xl p-8 absolute top-0 right-0 text-white z-50"
            >
              ☰
            </button>
          )}

          <img
            src="/img/NorseAdventures_2024 6-resize-compress.jpg"
            alt="A man standing on a cliff overlooking Hrafntinnusker"
            className="w-full h-full object-cover group-hover:brightness-110 bg-black"
          />
          <div className="absolute z-10 bottom-0 left-0 right-0 top-0 w-full h-full bg-gradient-to-t from-black to-transparent"></div>
          <div className="absolute z-20 h-full w-full flex flex-col items-start justify-end p-4 laptop:p-16 max-w-[1408px]">
            <div className="flex flex-col gap-4 mb-16 text-white">
              <span className="text-3xl font-medium drop-shadow-md uppercase">
                Luxury Tour
              </span>
              <span className="text-4xl tablet:text-5xl laptop:text-6xl laptop-lg:text-7xl desktop:text-8xl font-black drop-shadow-md uppercase">
                Golden Circle
              </span>
              <span className="font-bold text-lg">Most famous sights</span>
              <div className="flex flex-row flex-wrap gap-8">
                <div className="flex flex-row">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-10 w-10 block mr-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span>
                    <span className="block font-bold">Duration</span>8 hours
                  </span>
                </div>
                <div className="flex flex-row">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-10 w-10 block mr-4"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
                    <path fill-rule="evenodd" d="M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z" clip-rule="evenodd" />
                  </svg>
                  <span>
                    <span className="block font-bold">Season</span>
                    All year
                  </span>
                </div>
                <div className="flex flex-row">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-10 w-10 block mr-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span>
                    <span className="block font-bold">Difficulty</span>
                    Easy
                  </span>
                </div>
              </div>
              <div className="flex flex-row items-center gap-4">
                <button className="bokunButton" disabled id="bokun_7de90dac_e93a_4c01_9ec6_d8caaca1333c" data-src="https://widgets.bokun.io/online-sales/6b0f06ca-351c-45c7-bb92-cd248126f18f/experience-calendar/689360?partialView=1" data-testid="widget-book-button" > Book now </button>
                <span className="text-xl font-bold">240.000 ISK/group</span>
              </div>
            </div>
          </div>
        </header>

        <div className="description flex flex-row p-4 laptop:p-16 w-full max-w-screen-desktop">
          <div class="flex flex-col">
            <div className="flex flex-row gap-16">
              <div className="description-text">
                <p className="text-3xl font-bold text-black lg:mx-auto">
                  Intro
                </p>
                <div className="mt-4 text-lg text-black lg:mx-auto">

                  <p>Embark on an unforgettable journey through Iceland's Golden Circle, where nature's wonders and rich history collide!</p><br />

                  <p>Discover Þingvellir National Park, where the North American and Eurasian tectonic plates dramatically part ways and Vikings forged democracy at the world's oldest parliament.</p><br />

                  <p>Experience the awe-inspiring Geysir geothermal area, where explosive geysers shoot steaming hot water skyward amid bubbling mud pools.</p><br />

                  <p>Last but not least, marvel at Gullfoss waterfall, a stunning cascade that often paints rainbows across its misty embrace. Experience these natural wonders in style — your unforgettable journey through Iceland starts here!</p>

                </div>

                <div className="itinerary mt-16">
                  {/* HIGHLIGHTS */}
                  <p className="text-xl font-bold text-black lg:mx-auto">Highlights</p>
                  <div className="flex text-lg flex-col mt-8 gap-8 items-start">

                    {/* #1 */}
                    <div className="flex flex-row gap-4 justify-center items-start">
                      <div className="flex mb-2">
                        <span className="bg-gray-200 rounded-full p-2">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                            <path fill-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clip-rule="evenodd" />
                          </svg>
                        </span>
                      </div>
                      <div>
                        <span className="font-bold flex flex-row gap-2 items-center">
                          <span>Guided by Icelandic locals</span>
                        </span>
                        <span>Learn about our culture and traditions, and make a friend</span>
                      </div>
                    </div>

                    {/* #2 */}
                    <div className="flex flex-row gap-4 justify-center items-start">
                      <div className="flex mb-2">
                        <span className="bg-gray-200 rounded-full p-2">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                            <path fill-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clip-rule="evenodd" />
                          </svg>
                        </span>
                      </div>
                      <div>
                        <span className="font-bold flex flex-row gap-2 items-center">
                          <span>Luxurious vehicle</span>
                        </span>
                        <span>Travel in style and comfort with our luxurious vehicle</span>
                      </div>
                    </div>

                  </div>


                </div>

                <div className="flex flex-row w-full mt-16 gap-16">
                  <div className="">
                    <p className="text-xl font-bold text-black lg:mx-auto">
                      Included
                    </p>
                    <p className="mt-4 text-black lg:mx-auto flex flex-row items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 inline-block text-green-700"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      Pick-up and drop-off in Reykjavik.
                    </p>
                    <p className="mt-4 text-black lg:mx-auto flex flex-row items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 inline-block text-green-700"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      Local certified guide.
                    </p>
                    <p className="mt-4 text-black lg:mx-auto flex flex-row items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 inline-block text-green-700"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      Experienced and licensed driver.
                    </p>
                    <p className="mt-4 text-black lg:mx-auto flex flex-row items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 inline-block text-green-700"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      Ride in a luxurious vehicle.
                    </p>
                    <p className="mt-4 text-black lg:mx-auto flex flex-row items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 inline-block text-green-700"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      Vehicle fuel.
                    </p>

                    <p className="mt-4 text-black lg:mx-auto flex flex-row items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 inline-block text-green-700"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      Admission fees and parking fees.
                    </p>
                    <p className="mt-4 text-black lg:mx-auto flex flex-row items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 inline-block text-green-700"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      Agency support 24/7.
                    </p>
                  </div>
                  <div className="">
                    <p className="text-xl font-bold text-black lg:mx-auto">
                      Not included
                    </p>
                    <p className="mt-4 text-black lg:mx-auto flex flex-row items-center gap-2">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5 inline-block text-red-700">
                        <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm3 10.5a.75.75 0 0 0 0-1.5H9a.75.75 0 0 0 0 1.5h6Z" clip-rule="evenodd" />
                      </svg>
                      Trip insurance.
                    </p>
                    <p className="mt-4 text-black lg:mx-auto flex flex-row items-center gap-2">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5 inline-block text-red-700">
                        <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm3 10.5a.75.75 0 0 0 0-1.5H9a.75.75 0 0 0 0 1.5h6Z" clip-rule="evenodd" />
                      </svg>
                      Anything before or after the trip.
                    </p>
                    <p className="mt-4 text-black lg:mx-auto flex flex-row items-center gap-2">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5 inline-block text-red-700">
                        <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm3 10.5a.75.75 0 0 0 0-1.5H9a.75.75 0 0 0 0 1.5h6Z" clip-rule="evenodd" />
                      </svg>
                      Everything not specified in "Included".
                    </p>
                  </div>
                </div>

              </div>
              <div className="calendar w-full max-w-[496px]">
                <div class="bokunWidget" data-src="https://widgets.bokun.io/online-sales/6b0f06ca-351c-45c7-bb92-cd248126f18f/experience-calendar/689360"></div>
                <noscript>Please enable javascript in your browser to book</noscript>

              </div>
            </div>
            <section className="text-gray-700">
              <div className="grid grid-cols-3 gap-4 mt-16">
                {this.state.gallery.length > 0 ? (
                  this.state.gallery.map((e, id) => (
                    <div data-id={id + 1} className="overflow-hidden flex flex-wrap w-full h-72" onClick={() => this.handleOpen(id + 1)}>
                      <div className="w-full h-full">
                        <img
                          alt="gallery"
                          className="block object-cover object-center w-full h-full rounded-lg hover:brightness-110 cursor-pointer bg-black"
                          src={e.url}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <span className="text-4xl col-span-full text-center">
                    No Photos Found
                  </span>
                )}
              </div>
            </section>
          </div>
        </div>

        {/* FAQ - Frequently Asked Questions */}
        <div className="grid grid-cols-1 p-4 laptop:p-16 w-full max-w-screen-desktop pt-0 laptop:pt-0">
          <div className="flex flex-col">
            <section className="w-full">
              <div className="mb-8 lg:text-center">
                <p className="text-xl font-bold text-black lg:mx-auto">
                  FAQ - Frequently Asked Questions
                </p>
              </div>

              <Accordion bordered>
                <Accordion.Panel header="How fit do I need to be?" eventKey={1}>
                  <Placeholder.Paragraph />
                </Accordion.Panel>
                <Accordion.Panel header="What do I need to bring?" eventKey={2}>
                  <Placeholder.Paragraph />
                </Accordion.Panel>
                <Accordion.Panel header="Where do we have lunch?" eventKey={3}>
                  <Placeholder.Paragraph />
                </Accordion.Panel>
                <Accordion.Panel header="Are there any river crossings during the trip?" eventKey={6}>
                  <Placeholder.Paragraph />
                </Accordion.Panel>
                <Accordion.Panel header="Group sizes and age requirements" eventKey={7}>
                  <Placeholder.Paragraph />
                </Accordion.Panel>
                <Accordion.Panel header="Getting there and meeting location" eventKey={8}>
                  <Placeholder.Paragraph />
                </Accordion.Panel>
                <Accordion.Panel header="Deposits and cancellation policy" eventKey={9}>
                  <Placeholder.Paragraph />
                </Accordion.Panel>
              </Accordion>
            </section>
          </div>
        </div>

        <Reviews />
        <Subscribe />
        <Footer />

        <Modal size="lg" open={this.state.modalOpen} onClose={this.handleClose}>
          <Modal.Header></Modal.Header>
          <Modal.Body>
            <div className="w-full h-full">
              <img
                alt="gallery"
                className="block object-cover object-center w-full h-full rounded-lg hover:brightness-110 cursor-pointer"
                src={this.state.gallery[this.state.modalCurrentID - 1].url}
              />
            </div>
          </Modal.Body>
        </Modal>

        <a onClick={this.previousImage} hidden={this.state.modalOpen ? false : true} className="z-[1060] sticky bottom-[calc(50%-3rem)] right-full p-12 bg-white -mt-36 cursor-pointer select-none">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12">
            <path fill="#ffffff" strokeLinecap="round" strokeLinejoin="round" d="m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </a>

        <a onClick={this.nextImage} hidden={this.state.modalOpen ? false : true} className="z-[1060] sticky bottom-[calc(50%-3rem)] left-full p-12 bg-white -mt-36 cursor-pointer select-none">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12">
            <path fill="#ffffff" strokeLinecap="round" strokeLinejoin="round" d="m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </a>
      </div>
    );
  }
}
